import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {Http} from '@angular/http';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {SettingsAmenity} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {SettingsAmenitiesService} from '../../../services/settings-amenities.service';
import {AuthTokenService} from '../../../services/auth-token.service';
import {catchError, tap} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'schedule-modal',
    templateUrl: './schedule-modal.component.html',
    styleUrls: ['./schedule-modal.component.scss']
})
export class ScheduleModalComponent implements OnInit {
    @ViewChild('form') form;
    @ViewChild('mondayCheckbox') mondayCheckbox: ElementRef;
    @ViewChild('tuesdayCheckbox') tuesdayCheckbox: ElementRef;
    @ViewChild('wednesdayCheckbox') wednesdayCheckbox: ElementRef;
    @ViewChild('thursdayCheckbox') thursdayCheckbox: ElementRef;
    @ViewChild('fridayCheckbox') fridayCheckbox: ElementRef;
    @ViewChild('saturdayCheckbox') saturdayCheckbox: ElementRef;
    @ViewChild('sundayCheckbox') sundayCheckbox: ElementRef;
    @ViewChild('submitButton') submitButton: ElementRef;
    showModal = false;
    data: SettingsAmenity = new SettingsAmenity();
    disabledSubmit = false;
    disabledFileInput = false;
    attachments: Array<any> = [];
    hoursArray: Array<any> = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
    minutesArray: Array<any> = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
    weekDaysNamesArray: Array<any> = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    checkInTime: { hours: string, minutes: string, amPM: string } = {hours: '', minutes: '', amPM: ''};
    checkOutTime: { hours: string, minutes: string, amPM: string } = {hours: '', minutes: '', amPM: ''};
    weekDays: Array<any> = [];
    amenityTemplates = [];
    amenityTemplatesLoadingSpinner = false;
    amenityAsTemplate = null;
    isMinutesStepError: boolean;
    intervalId: number;

    constructor(
        public api: ApiClientService,
        public settingsAmenitiesService: SettingsAmenitiesService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        private http: Http,
        private authTokenService: AuthTokenService
    ) {
    }

    ngOnInit() {
        this.initData();
        this.getAmenityTemplates();
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.data = Object.assign({}, this.settingsAmenitiesService.selectedItemData);
        this.getDayHoursFormatted();
        if (this.data.rule) {
            if (this.data.rule.checkOutTime)
                this.checkOutTime = this.getScheduleTimeSplitted(this.data.rule.checkOutTime);
            if (this.data.rule.checkInTime)
                this.checkInTime = this.getScheduleTimeSplitted(this.data.rule.checkInTime);
        }
        setTimeout(() => this.getCheckboxesChecked(), 500);
    }

    hideModal() {
        let oneOfTheSelectsWasTouched = false;
        for (let i = 0; i < document.getElementsByTagName('select').length; i++) {
            if ((<any>document.getElementsByTagName('select')[i].classList).value.indexOf('ng-dirty') != -1)
                oneOfTheSelectsWasTouched = true;
        }
        if ((this.form.dirty && this.form.touched) || oneOfTheSelectsWasTouched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.settingsAmenitiesService.isScheduleModalShow = false;
                    this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.settingsAmenitiesService.isScheduleModalShow = false;
            this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    getHourlyStatus(formValue: Record<string, any>): string {
        let status = '';
        for (const weekday of this.weekDays) {
            for (let i = 0; i < weekday.dayHours.length; i++) {
                const minHour = this.getTime(null, null, null, weekday.dayHours[i].minHour.hour, weekday.dayHours[i].minHour.minutes, weekday.dayHours[i].minHour.amPM);
                const endDayCheckForNextDayBeginning = weekday.dayHours[i].maxHour.hour == '12' && weekday.dayHours[i].maxHour.amPM == 'AM' ? '02' : '01';
                const maxHour = this.getTime(null, endDayCheckForNextDayBeginning, null, weekday.dayHours[i].minHour.hour, weekday.dayHours[i].minHour.minutes, weekday.dayHours[i].minHour.amPM);
                if ((maxHour - minHour) / 3600000 < +formValue.bookingMinHour) {
                    if (status.indexOf(this.weekDaysNamesArray[weekday.dayNumber - 1]) == -1)
                        status += this.weekDaysNamesArray[weekday.dayNumber - 1] + ', ';
                }
            }
        }
        return status;
    }

    isScheduleTimeOverlapping(formValue: Record<string, any>) {
        for (const weekday of this.weekDays) {
            for (let i = 0; i < weekday.dayHours.length; i++) {
                const minHourTime = this.getTime(null, null, null, weekday.dayHours[i].minHour.hour, weekday.dayHours[i].minHour.minutes, weekday.dayHours[i].minHour.amPM);
                const endDayCheckForNextDayBeginning = weekday.dayHours[i].maxHour.hour == '12' && weekday.dayHours[i].maxHour.amPM == 'AM' ? '02' : '01';
                const maxHour = this.getTime(null, endDayCheckForNextDayBeginning, null, weekday.dayHours[i].maxHour.hour, weekday.dayHours[i].maxHour.minutes, weekday.dayHours[i].maxHour.amPM);

                for (let j = 0; j < weekday.dayHours.length; j++) {
                    if (i !== j) {
                        const minHourComparable = this.getTime(null, null, null, weekday.dayHours[j].minHour.hour, weekday.dayHours[j].minHour.minutes, weekday.dayHours[j].minHour.amPM);
                        const endDayComparableCheckForNextDayBeginning = weekday.dayHours[j].maxHour.hour == '12' && weekday.dayHours[j].maxHour.amPM == 'AM' ? '02' : '01';
                        const maxHourComparable = this.getTime(null, endDayComparableCheckForNextDayBeginning, null, weekday.dayHours[j].maxHour.hour, weekday.dayHours[j].maxHour.minutes, weekday.dayHours[j].maxHour.amPM);
                        // if start time is in chosen range
                        if ((formValue.timeSequenceType == 'hourly' && (minHourTime >= minHourComparable && minHourTime <= maxHourComparable)) ||
                            (formValue.timeSequenceType == 'range' && (minHourTime > minHourComparable && minHourTime < maxHourComparable))) {
                            return true;
                        }
                        // if end time is in chosen range
                        if ((formValue.timeSequenceType == 'hourly' && (maxHour >= minHourComparable && minHourTime <= maxHourComparable)) ||
                            (formValue.timeSequenceType == 'range' && (maxHour > minHourComparable && minHourTime < maxHourComparable))) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }

    getTime(month = '01', day = '01', year = '1970', hour, minutes, amPm: 'AM' | 'PM'): number {
        return new Date(`${month}/${day}/${year} ${hour}:${minutes} ${amPm}`).getTime();
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.checkinHours || !form.value.checkinMinutes || !form.value.checkinAmPm)
                toastr.warning('All Check In Details must be filled');
            if (!form.value.checkoutHours || !form.value.checkoutMinutes || !form.value.checkoutAmPm)
                toastr.warning('All Check Out Details must be filled');
            return;
        }

        if (form.value.timeSequenceType == 'daily' && this.checkInTimeIsLessThanCheckOutTime()) {
            toastr.warning('Check In time must be greater than Check Out Time');
            return;
        }

        if (this.data.saveAsTemplate) {
            if (!this.data.templateName) {
                toastr.warning('Template name must not be blank');
                return;
            }
        }

        if (form.value.timeSequenceType == 'hourly' || form.value.timeSequenceType == 'range') {
            if (form.value.timeSequenceType == 'hourly' && +form.value.bookingMinHour) {
                const status = this.getHourlyStatus(form.value);
                if (status) {
                    toastr.warning(`The time entered for ${status.slice(0, -2)} does not match the minimum hours rule`);
                    return;
                }
            }
            if (this.isScheduleTimeOverlapping(form.value)) {
                toastr.warning('Schedule time cannot equal or be a part of other interval');
                return;
            }
        }
        if (!this.checkIfAllTimeFieldsAreComplete()) {
            toastr.warning('All Day times elements should be filled');
            return;
        }

        const data: any = {timeSequenceType: form.value.timeSequenceType};

        if (form.value.timeSequenceType == 'daily') {
            data.dailyRule = {
                bookingMinDay: 1,
                bookingMaxDay: +form.value.bookingMaxDay,
                checkInTime: this.formatScheduleTime(form, 'checkin'),
                checkOutTime: this.formatScheduleTime(form, 'checkout'),
                limitActivityBookingOrDays: 'booking',
                weekDays: this.convertWeekDaysTimes()
            };
        } else {
            if (form.value.timeSequenceType == 'hourly') {
                data.hourlyRule = {
                    bookingMinHour: +form.value.bookingMinHour,
                    bookingMaxHour: +form.value.bookingMaxHour,
                    timeStep: 30,
                    limitActivityBookingOrHours: 'booking',
                    weekDays: this.convertWeekDaysTimes()
                };
            }
            if (form.value.timeSequenceType == 'range') {
                data.rangeRule = {weekDays: this.convertWeekDaysTimes()};
            }
        }

        //Rewriting the fees in case the amenity type was change(problem with daily and hourly fees.)
        const fees = JSON.parse(JSON.stringify(this.settingsAmenitiesService.selectedItemData.fees));
        fees.forEach(f => {
            f.pmtAtTime = 0;
            f.pmtHourly = 0;
        });
        data.fees = fees.map(f => ({
            active: f.active,
            amount: f.amount,
            name: f.name,
            pmtAtTime: f.pmtAtTime,
            pmtHourly: f.pmtHourly,
            refundable: f.refundable,
            required: f.required
        }));

        this.disabledSubmit = true;
        if (this.data.saveAsTemplate)
            this.setupTemplate();

        const url = `/v1/amenity/${this.settingsAmenitiesService.selectedItemData.id}.json`;
        this.settingsAmenitiesService.api.patch('domainAmenities', url, data)
            .pipe(
                tap((r) => {
                    toastr.success('The Field was successfully updated');
                    if (this.data.saveAsTemplate) {
                        this.saveAsTemplate();
                    }
                    this.form.reset();
                    this.settingsAmenitiesService.getData();
                    this.settingsAmenitiesService.isScheduleModalShow = false;
                    this.settingsAmenitiesService.serviceRequestInServiceRequestModal = null;
                }),
                catchError((error) => {
                    this.amenityAsTemplate = null;
                    this.disabledSubmit = false;
                    let errorText = '';
                    JSON.parse(error._body).errors.filter(error => errorText += error.description + '. ');
                    this.api.errorHandler(error, errorText);
                    return of(error);
                })
            )
            .subscribe();
    }

    onMinutesStepChange(newMinutesStep: number, select: HTMLSelectElement) {
        if (!this.isCanSetStep(+newMinutesStep)) {
            this.showMinutesStepErrorMessage();
            select.value = this.data.minutesStep.toString();
        } else {
            const minutesArray = [];
            let minute = 0;
            const minutesArrayFillInterval = setInterval(() => {
                if (minute < 60) {
                    minutesArray.push(minute < 10 ? `0${minute}` : minute);
                    minute += +newMinutesStep;
                } else {
                    clearInterval(minutesArrayFillInterval);
                    this.minutesArray = minutesArray;
                    this.data.minutesStep = newMinutesStep;
                }
            }, 1000 / 60);
        }
    }

    isCanSetStep(step: number): boolean {
        return this.weekDays
            .every(day => day.dayHours.every(hours => {
                let isMinHoursAllow: boolean;
                let isMaxHoursAllow: boolean;
                if (+hours.minHour.minutes === 0) {
                    isMinHoursAllow = true;
                } else {
                    isMinHoursAllow = +hours.minHour.minutes >= step;
                }

                if (+hours.maxHour.minutes === 0) {
                    isMaxHoursAllow = true;
                } else {
                    isMaxHoursAllow = +hours.maxHour.minutes >= step;
                }

                return isMinHoursAllow && isMaxHoursAllow;
            }));
    }

    showMinutesStepErrorMessage(): void {
        clearInterval(this.intervalId);
        this.isMinutesStepError = true;
        this.intervalId = setTimeout(() => this.isMinutesStepError = false, 3000);
    }

    checkIfAllTimeFieldsAreComplete(): boolean {
        let allFilled = true;
        if (this.data.timeSequenceType == 'hourly' || this.data.timeSequenceType == 'range') {
            this.weekDays.filter((day) => {
                day.dayHours.filter((hours) => {
                    if (!hours.minHour.hour || !hours.minHour.minutes || !hours.minHour.amPM ||
                        !hours.maxHour.hour || !hours.maxHour.minutes || !hours.maxHour.amPM)
                        allFilled = false;
                });
            });

        }
        return allFilled;
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.settingsAmenitiesService.getData();
        this.form.reset();
        this.hideModal();
    }

    removeFile(i: number) {
        swal(
            ConstantsService.getSwalConfig('Delete Attachment'),
            () => this.attachments.splice(i, 1)
        );
    }

    onDayCheckboxValueChange(checkBoxName, dayNumber): void {
        if (this[checkBoxName].nativeElement.checked) {
            let weekDay = null;
            if (this.data.timeSequenceType == 'daily')
                weekDay = {dayNumber: dayNumber};
            else {
                weekDay = {
                    dayNumber: dayNumber,
                    dayHours: [{
                        minHour: {hour: '', minutes: '', amPM: ''},
                        maxHour: {hour: '', minutes: '', amPM: ''}
                    }]
                };
            }
            this.weekDays.push(weekDay);
        } else {
            // const weekDay = this.weekDays[this.getDayIndexInWeekDaysArray(dayNumber)];
            // const weekDayIsEmpty = !weekDay.dayHours || weekDay.dayHours.length === 0
            //     || !weekDay.dayHours.some(
            //         dayHour => dayHour.maxHour.hour || dayHour.maxHour.minutes || dayHour.minHour.hour || dayHour.minHour.minutes
            //     );
            // if (weekDayIsEmpty) {
            //     this.removeWeekDay(dayNumber);
            // } else {
            //     swal(ConstantsService.getSwalConfig('Are you sure?', 'This action will delete all the time adjustments for this day'),
            //         (agreed: boolean) => {
            //             if (agreed) {
            //                 this.removeWeekDay(dayNumber);
            //             }
            //         }
            //     );
            // }
            // @todo uncomment these lines and add choice to the user
            this.removeWeekDay(dayNumber);
        }
    }

    removeWeekDay(dayNumber: number) {
        this.weekDays = this.weekDays.filter(weekDay => weekDay.dayNumber !== dayNumber);
    }

    checkboxIsChecked(checkBoxName): boolean {
        return this[checkBoxName].nativeElement.checked;
    }

    addTimeSlot(dayName, dayNumber, timeRowIndex) {
        this.weekDays[this.getDayIndexInWeekDaysArray(dayNumber)].dayHours.splice(timeRowIndex + 1, 0, {
            minHour: {hour: '', minutes: '', amPM: ''},
            maxHour: {hour: '', minutes: '', amPM: ''}
        });
    }

    deleteTimeSlot(dayNumber, timeRowIndex): void {
        let index = -1;
        for (let i = 0; i < this.weekDays.length; i++) {
            if (this.weekDays[i].dayNumber == dayNumber)
                index = i;
        }
        this.weekDays[this.getDayIndexInWeekDaysArray(dayNumber)].dayHours.splice(timeRowIndex, 1);
    }

    onTimeSequenceChange(event): void {
        if (this.data.timeSequenceType == 'daily') {
            if (this.mondayCheckbox.nativeElement.checked) {
                this.pushTimeRowToWeekDaysArrayByDayNumber(1);
            }
            if (this.tuesdayCheckbox.nativeElement.checked) {
                this.pushTimeRowToWeekDaysArrayByDayNumber(2);
            }
            if (this.wednesdayCheckbox.nativeElement.checked) {
                this.pushTimeRowToWeekDaysArrayByDayNumber(3);
            }
            if (this.thursdayCheckbox.nativeElement.checked) {
                this.pushTimeRowToWeekDaysArrayByDayNumber(4);
            }
            if (this.fridayCheckbox.nativeElement.checked) {
                this.pushTimeRowToWeekDaysArrayByDayNumber(5);
            }
            if (this.saturdayCheckbox.nativeElement.checked) {
                this.pushTimeRowToWeekDaysArrayByDayNumber(6);
            }
            if (this.sundayCheckbox.nativeElement.checked) {
                this.pushTimeRowToWeekDaysArrayByDayNumber(7);
            }
        }
        this.data.timeSequenceType = event.target.value;
    }

    pushTimeRowToWeekDaysArrayByDayNumber(number): void {
        if (this.getDayIndexInWeekDaysArray(number) == -1) {
            this.weekDays.push({
                dayNumber: number,
                dayHours: [{
                    minHour: {hour: '', minutes: '', amPM: ''},
                    maxHour: {hour: '', minutes: '', amPM: ''}
                }]
            });
        } else {
            this.weekDays[this.getDayIndexInWeekDaysArray(number)].dayHours = [{
                minHour: {hour: '', minutes: '', amPM: ''},
                maxHour: {hour: '', minutes: '', amPM: ''}
            }];
        }
    }

    formatScheduleTime(form, checkinORcheckout): string {
        let hoursInt = (form.value[checkinORcheckout + 'Hours'] == '12' && form.value[checkinORcheckout + 'AmPm'] == 'AM' ? 0 : +form.value[checkinORcheckout + 'Hours']);

        if (+form.value[checkinORcheckout + 'Hours'] != 12 && form.value[checkinORcheckout + 'AmPm'] == 'PM')
            hoursInt += 12;
        return hoursInt + ':' + form.value[checkinORcheckout + 'Minutes'];
    }

    getDayIndexInWeekDaysArray(dayNumber): number {
        // let index = -1;
        // for (let i = 0; i < this.weekDays.length; i++) {
        //     if (this.weekDays[i].dayNumber == dayNumber)
        //         index = i;
        // }
        // return index;
        return this.weekDays.findIndex(weekDay => weekDay.dayNumber === dayNumber);
    }

    convertWeekDaysTimes(): any {
        const formattedArray = [];
        for (let i = 0; i < this.weekDays.length; i++) {
            const minMaxArray = [];
            if (this.data.timeSequenceType == 'hourly' || this.data.timeSequenceType == 'range') {
                for (let j = 0; j < this.weekDays[i].dayHours.length; j++) {
                    let minHour = '';
                    let maxHour = '';
                    let minHoursInt = this.weekDays[i].dayHours[j].minHour.hour == '12' && this.weekDays[i].dayHours[j].minHour.amPM == 'AM' ?
                        0 : +this.weekDays[i].dayHours[j].minHour.hour;
                    const minMinutes = this.weekDays[i].dayHours[j].minHour.minutes;
                    if (this.weekDays[i].dayHours[j].minHour.hour != 12 && this.weekDays[i].dayHours[j].minHour.amPM == 'PM')
                        minHoursInt += 12;
                    minHour = minHoursInt + ':' + minMinutes;


                    let maxHoursInt = this.weekDays[i].dayHours[j].maxHour.hour == '12' && this.weekDays[i].dayHours[j].maxHour.amPM == 'AM' ?
                        0 : +this.weekDays[i].dayHours[j].maxHour.hour;
                    const maxMinutes = this.weekDays[i].dayHours[j].maxHour.minutes;
                    if (this.weekDays[i].dayHours[j].maxHour.hour != 12 && this.weekDays[i].dayHours[j].maxHour.amPM == 'PM')
                        maxHoursInt += 12;
                    maxHour = maxHoursInt + ':' + maxMinutes;
                    minMaxArray.push({
                        minHour: minHour,
                        maxHour: maxHour
                    });
                }
                formattedArray.push({
                    dayNumber: this.weekDays[i].dayNumber,
                    dayHours: minMaxArray
                });
            } else if (this.data.timeSequenceType == 'daily') {
                formattedArray.push({dayNumber: this.weekDays[i].dayNumber});
            }
        }
        return formattedArray;
    }

    getDayHoursFormatted() {
        if (this.data.timeSequenceType == 'hourly' || this.data.timeSequenceType == 'range') {
            const formattedArray = [];
            for (let i = 0; i < this.data.rule.weekDays.length; i++) {
                const minMaxArray = [];
                for (let j = 0; j < this.data.rule.weekDays[i].dayHours.length; j++) {
                    const minHour = {hour: '', minutes: '', amPM: ''};
                    const maxHour = {hour: '', minutes: '', amPM: ''};
                    const dayHours = this.data.rule.weekDays[i].dayHours[j];
                    minHour.hour = new Date(new Date(dayHours.minHour).getTime() + new Date(dayHours.minHour).getTimezoneOffset() * 60000).getHours() > 12 ?
                        (new Date(new Date(dayHours.minHour).getTime() + new Date(dayHours.minHour).getTimezoneOffset() * 60000).getHours() - 12).toString() :
                        (new Date(new Date(dayHours.minHour).getTime() + new Date(dayHours.minHour).getTimezoneOffset() * 60000).getHours()).toString();
                    minHour.minutes = new Date(dayHours.minHour).getMinutes() > 9 ?
                        (new Date(dayHours.minHour).getMinutes()).toString() :
                        '0' + (new Date(dayHours.minHour).getMinutes()).toString();
                    minHour.amPM = new Date(new Date(dayHours.minHour).getTime() + new Date(dayHours.maxHour).getTimezoneOffset() * 60000).getHours() >= 12 ? 'PM' : 'AM';
                    if (minHour.hour == '0')
                        minHour.hour = '12';

                    maxHour.hour = new Date(new Date(dayHours.maxHour).getTime() + new Date(dayHours.maxHour).getTimezoneOffset() * 60000).getHours() > 12 ?
                        (new Date(new Date(dayHours.maxHour).getTime() + new Date(dayHours.maxHour).getTimezoneOffset() * 60000).getHours() - 12).toString() :
                        (new Date(new Date(dayHours.maxHour).getTime() + new Date(dayHours.maxHour).getTimezoneOffset() * 60000).getHours()).toString();
                    maxHour.minutes = new Date(dayHours.maxHour).getMinutes() > 9 ?
                        (new Date(dayHours.maxHour).getMinutes()).toString() :
                        '0' + (new Date(dayHours.maxHour).getMinutes()).toString();
                    maxHour.amPM = new Date(new Date(dayHours.maxHour).getTime() + new Date(dayHours.maxHour).getTimezoneOffset() * 60000).getHours() >= 12 ? 'PM' : 'AM';
                    if (maxHour.hour == '0')
                        maxHour.hour = '12';
                    minMaxArray.push({
                        minHour: minHour,
                        maxHour: maxHour
                    });
                }
                formattedArray.push({
                    dayNumber: this.data.rule.weekDays[i].dayNumber,
                    dayHours: minMaxArray
                });
            }
            this.weekDays = formattedArray;
        } else if (this.data.timeSequenceType == 'daily') {
            const formattedArray = [];
            for (let i = 0; i < this.data.rule.weekDays.length; i++) {
                formattedArray.push({dayNumber: this.data.rule.weekDays[i].dayNumber});
            }
            this.weekDays = formattedArray;
        }
    }

    getCheckboxesChecked(): void {
        if (this.data.rule && this.data.rule.weekDays) {
            for (let i = 0; i < this.data.rule.weekDays.length; i++) {
                if (this.data.rule.weekDays[i].dayNumber == 1)
                    this.mondayCheckbox.nativeElement.checked = true;
                if (this.data.rule.weekDays[i].dayNumber == 2)
                    this.tuesdayCheckbox.nativeElement.checked = true;
                if (this.data.rule.weekDays[i].dayNumber == 3)
                    this.wednesdayCheckbox.nativeElement.checked = true;
                if (this.data.rule.weekDays[i].dayNumber == 4)
                    this.thursdayCheckbox.nativeElement.checked = true;
                if (this.data.rule.weekDays[i].dayNumber == 5)
                    this.fridayCheckbox.nativeElement.checked = true;
                if (this.data.rule.weekDays[i].dayNumber == 6)
                    this.saturdayCheckbox.nativeElement.checked = true;
                if (this.data.rule.weekDays[i].dayNumber == 7)
                    this.sundayCheckbox.nativeElement.checked = true;
            }
        }
    }

    clickSubmit(): void {
        this.submitButton.nativeElement.click();
    }

    getScheduleTimeSplitted(time): any {
        const dateInCurrentTimezone = new Date(new Date(time).getTime() + new Date(time).getTimezoneOffset() * 60000);
        return {
            hours: dateInCurrentTimezone.getHours() > 12 ? (dateInCurrentTimezone.getHours() - 12).toString() :
                dateInCurrentTimezone.getHours() != 0 ? (dateInCurrentTimezone.getHours()).toString() : '12',
            minutes: dateInCurrentTimezone.getMinutes() > 9 ? (dateInCurrentTimezone.getMinutes()).toString() :
                '0' + (dateInCurrentTimezone.getMinutes()).toString(),
            amPM: dateInCurrentTimezone.getHours() >= 12 ? 'PM' : 'AM'
        };
    }

    getAmenityTemplates(): void {
        this.amenityTemplatesLoadingSpinner = true;
        this.amenityTemplates = [];
        const currentUserID = JSON.parse(localStorage.getItem('userData')).id;
        const url = `/v1/amenity_settings_template?per-page=1000&user_id=${currentUserID}`;
        this.api.get('domainAmenities', `${url}`).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                const entities = body.entities;
                this.amenityTemplates = entities.map(item => (item));
                this.amenityTemplatesLoadingSpinner = false;
            },
            (error) => this.api.errorHandler(error, 'Failed get Amenity Templates')
        );
    }

    saveAsTemplate(): void {
        const url = `/v1/amenity_settings_template.json`;
        this.api.post('domainAmenities', `${url}`, this.amenityAsTemplate).subscribe(
            (res) => toastr.success('The Template was successfully saved'),
            (error) => {
                let errorText = '';
                JSON.parse(error._body).errors.forEach(error => errorText += error.description + '. ');
                this.api.errorHandler(error, errorText);
            }
        );
    }

    setupTemplate(): void {
        let template = null;
        if (this.data.timeSequenceType == 'daily') {
            template = {
                bookingMaxDay: this.data.bookingMaxDay,
                checkOutTime: this.checkOutTime,
                checkInTime: this.checkInTime,
                weekDays: this.weekDays
            };
        }
        if (this.data.timeSequenceType == 'hourly') {
            template = {
                bookingMinHour: this.data.bookingMinHour,
                bookingMaxHour: this.data.bookingMaxHour,
                weekDays: this.weekDays
            };
        }
        if (this.data.timeSequenceType == 'range') {
            template = {weekDays: this.weekDays};
        }
        this.amenityAsTemplate = {
            name: this.data.templateName,
            timeSequenceType: this.data.timeSequenceType,
            settings: JSON.stringify(template)
        };
    }

    setAmenityFromTemplate(event): void {
        this.amenityTemplates.forEach((template) => {
            if (template.name == event) {
                this.data.timeSequenceType = template.timeSequenceType;
                const templateSettings = JSON.parse(template.settings);
                if (template.timeSequenceType == 'daily') {
                    this.data.bookingMaxDay = templateSettings.bookingMaxDay;
                    this.checkOutTime = templateSettings.checkOutTime;
                    this.checkInTime = templateSettings.checkInTime;
                    this.weekDays = templateSettings.weekDays;
                } else if (template.timeSequenceType == 'hourly') {
                    this.data.bookingMinHour = templateSettings.bookingMinHour;
                    this.data.bookingMaxHour = templateSettings.bookingMaxHour;
                    this.weekDays = templateSettings.weekDays;
                } else if (template.timeSequenceType == 'range') {
                    this.weekDays = templateSettings.weekDays;
                }
                this.getCheckboxesCheckedOnTemplateChange();
            }
        });
    }

    getCheckboxesCheckedOnTemplateChange(): void {
        let monday = false;
        let tuesday = false;
        let wednesday = false;
        let thursday = false;
        let friday = false;
        let saturday = false;
        let sunday = false;
        if (this.weekDays) {
            for (let i = 0; i < this.weekDays.length; i++) {
                if (this.weekDays[i].dayNumber == 1)
                    monday = true;
                if (this.weekDays[i].dayNumber == 2)
                    tuesday = true;
                if (this.weekDays[i].dayNumber == 3)
                    wednesday = true;
                if (this.weekDays[i].dayNumber == 4)
                    thursday = true;
                if (this.weekDays[i].dayNumber == 5)
                    friday = true;
                if (this.weekDays[i].dayNumber == 6)
                    saturday = true;
                if (this.weekDays[i].dayNumber == 7)
                    sunday = true;
            }
        }
        this.mondayCheckbox.nativeElement.checked = monday;
        this.tuesdayCheckbox.nativeElement.checked = tuesday;
        this.wednesdayCheckbox.nativeElement.checked = wednesday;
        this.thursdayCheckbox.nativeElement.checked = thursday;
        this.fridayCheckbox.nativeElement.checked = friday;
        this.saturdayCheckbox.nativeElement.checked = saturday;
        this.sundayCheckbox.nativeElement.checked = sunday;
    }

    checkInTimeIsLessThanCheckOutTime(): boolean {
        let flag = false;
        const checkInTimeComparable = new Date(`01/01/1970 ${this.checkInTime.hours + ':' + this.checkInTime.minutes + ' ' + this.checkInTime.amPM}`);
        const checkOutTimeComparable = new Date(`01/01/1970 ${this.checkOutTime.hours + ':' + this.checkOutTime.minutes + ' ' + this.checkOutTime.amPM}`);
        if (checkInTimeComparable < checkOutTimeComparable)
            flag = true;
        return flag;
    }

    copyScheduleToDay(index, copyToDay, isForward: boolean = true) {
        const indexInWeekDaysArray = this.getDayIndexInWeekDaysArray(copyToDay);
        if (indexInWeekDaysArray != -1) {
            this.weekDays[indexInWeekDaysArray].dayHours = JSON.parse(JSON.stringify(this.weekDays[this.getDayIndexInWeekDaysArray(index)].dayHours));
        } else {
            if (isForward) {
                if (copyToDay + 1 < 8) {
                    this.copyScheduleToDay(index, copyToDay + 1, isForward);
                }
            } else {
                if (copyToDay - 1 > 0) {
                    this.copyScheduleToDay(index, copyToDay - 1, isForward);
                }
            }
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/schedule-modal/schedule-modal.component.ts